export const EmbeddedCode = ({ code }) => {
  return (
    <div className="container flex flex-col px-4 mx-auto md:w-9/12 ">
      <div dangerouslySetInnerHTML={{ __html: code }} />
    </div>
  )
}
